import { createSlice } from '@reduxjs/toolkit'

import { referencesSelectors } from '../selectors/references'

const initialState = {
    groups: [],
    teachers: [],
    subjects: [],
    classTypes: [],
    buildings: [],
    bells: [],
    rooms: [],
    editorRooms: [],
    loading: {
        groups: false,
        teachers: false,
        subjects: false,
        classTypes: false,
        buildings: false,
        bells: false,
        audience: false,
        editorAudience: false,
    },
    error: null,
}

const references = createSlice({
    name: 'references',
    initialState,
    reducers: {
        setTableLoading: (state, action) => {
            const { table, value } = action.payload
            state.loading[table] = value
        },
        setGroups: (state, action) => {
            state.groups = action.payload
        },
        setTeachers: (state, action) => {
            state.teachers = action.payload
        },
        setSubjects: (state, action) => {
            state.subjects = action.payload
        },
        setClassTypes: (state, action) => {
            state.classTypes = action.payload
        },
        setBuildings: (state, action) => {
            state.buildings = action.payload
        },
        setBells: (state, action) => {
            state.bells = action.payload
        },
        setRooms: (state, action) => {
            state.rooms = action.payload
        },
        setEditorRooms: (state, action) => {
            state.editorRooms = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        resetRooms: (state) => {
            state.rooms = []
        },
        resetEditorRooms: (state) => {
            state.editorRooms = []
        },
    },
    selectors: {
        ...referencesSelectors,
    },
})

export const referencesSelector = references.getSelectors()
export const referencesActions = references.actions

export default references.reducer
